<template>
  <div class="m_consulting project_detail">
    <mt-header title="Enquiry">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <ul class="ul_list">
      <li class="ul_item" v-for="item in inbox" :key="item.id" @click="dialogue(item)">
        <div class="ul_item_left">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/timg.jpg" alt="" />
        </div>
        <div class="ul_item_right">
          <p class="consulting_p">
            <span class="consulting_title">{{item.name?item.name:item.nickname}}</span>
            <span class="consulting_time">{{item.ctime}}</span>
          </p>
          <p class="consulting_p">
            {{item.content}}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import { reqMynote,  } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      inbox:[],
      detailObj:{
        corp_info:{},
        pro_info:{},
        list:[]
      },
      centerDialogVisible: false,
      textarea:"",//聊天框输入内容
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(){
      const response = await reqMynote()
      if (response.code==2) {
        // this.inbox=response.inbox
       this.inbox = this.screening(response.inbox)
      }
    },
    screening(arr){
      for(var i=0; i<arr.length; i++){//数组去重
        for(var j=i+1; j<arr.length; j++){
          if(arr[i].id*1==arr[j].id*1){
            arr.splice(j,1);
            j--;
          }
        }
        }
      return arr;
    },
    async dialogue(item){//详情
      this.$router.push('/userapp/consulting/achat/'+item.sendid+'/'+item.putid+'/'+item.pid)
      // this.item = item
      // const response = await reqMynoteOne(item.sendid,item.putid,item.pid)
      // if (response.code==3) {//数据正常
      //   this.detailObj = {
      //     corp_info:response.corp_info,
      //     pro_info:response.pro_info,
      //     list:response.reslist.reverse(),
      //   }
      //   this.centerDialogVisible=true
      //   setTimeout(()=>{
      //     this.$refs.box.scrollTop = this.$refs.box.scrollHeight
      //   })
      // }else if(response.code==2){
      //   if (this.centerDialogVisible) {//判断是否是在详情页面
      //     this.centerDialogVisible=false
      //     this.init()
      //   }
      // }
    }
  }
}
</script>

<style scoped>
  .m_consulting{
    width: 100%;
    height: 100%;
  }

  .ul_item{
    width: 100%;
    background-color: rgb(255, 255, 255);
    padding: 10px;
    display: flex;
    margin-top: 6px;
  }
  .ul_item_left{
    width: 50px;
    margin-right: 10px;
  }
  .ul_item_right{
    width: calc(100% - 60px);
  }
  .consulting_p+.consulting_p{
    margin-top: 6px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .consulting_time{
    font-size: 12px;
  }
  .consulting_title{
    font-size: 14px;
    font-weight: 600;
    margin-right: 6px;
  }


  
</style>